<template>
	<h-disclosure
		v-slot="{open}"
		as="div"
		:default-open="isOpen"
		class="w-full"
		:class="{
			'border-none': !hasBorder,
			'border-b': hasBorder,
		}"
	>
		<v-disclosure-button
			v-if="buttonPosition === 'top'"
			class="flex w-full items-center justify-between space-x-md pr-md text-left"
			:class="{
				'py-md': size === 'md',
				'py-3': size === 'sm',
			}"
		>
			<slot name="button" :is-open="open" />

			<template v-if="expandType === 'chevron'">
				<v-icon v-if="open" icon="chevron-up" class="text-xl"></v-icon>

				<v-icon v-else icon="chevron-down" class="text-xl"></v-icon>
			</template>

			<template v-else-if="expandType === 'plus'">
				<v-icon v-if="open" icon="minus" class="text-xl"></v-icon>

				<v-icon v-else icon="add" class="text-xl"></v-icon>
			</template>
		</v-disclosure-button>

		<transition
			enter-active-class="transition duration-100 ease-out"
			enter-from-class="transform scale-95 opacity-0"
			enter-to-class="transform scale-100 opacity-100"
			leave-active-class="transition duration-75 ease-out"
			leave-from-class="transform scale-100 opacity-100"
			leave-to-class="transform scale-95 opacity-0"
		>
			<v-disclosure-panel class="pb-sm">
				<slot name="content" />
			</v-disclosure-panel>
		</transition>

		<v-disclosure-button
			v-if="buttonPosition === 'bottom'"
			class="flex w-full items-center justify-between space-x-md pr-md text-left"
			:class="{
				'py-md': size === 'md',
				'py-3': size === 'sm',
			}"
		>
			<slot name="button" :is-open="open" />

			<template v-if="expandType === 'chevron'">
				<v-icon v-if="open" icon="chevron-up" class="text-xl"></v-icon>

				<v-icon v-else icon="chevron-down" class="text-xl"></v-icon>
			</template>

			<template v-else-if="expandType === 'plus'">
				<v-icon v-if="open" icon="minus" class="text-xl"></v-icon>

				<v-icon v-else icon="add" class="text-xl"></v-icon>
			</template>
		</v-disclosure-button>
	</h-disclosure>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		expandType?: "plus" | "chevron" | "none";
		isOpen?: boolean;
		hasBorder?: boolean;
		size?: "sm" | "md";
		buttonPosition?: "top" | "bottom";
	}>(),
	{
		expandType: "plus",
		size: "md",
		buttonPosition: "top",
	},
);
</script>
